var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHouse4({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "m1.5 9.744 10.5-9 10.5 9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M12 5.244 3.377 12.61a1.186 1.186 0 0 0-.377.8v8.855a.981.981 0 0 0 .978.978H9.75v-7.01a.491.491 0 0 1 .489-.49h3.522a.491.491 0 0 1 .489.49v7.01h5.772a.981.981 0 0 0 .978-.977v-8.855a1.186 1.186 0 0 0-.377-.8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse4);
export default __webpack_public_path__ + "static/media/house-4.dc80682b31022909ea7d1b678c804c65.svg";
export { ForwardRef as ReactComponent };